import type { ReactNode } from "react";

/** Dashed container for AI Debug Mode diagnostics; never shown to end users. */
export function AiDebugPanel({ title = "Debug", children }: { title?: string; children: ReactNode }) {
  return (
    <div className="space-y-2 rounded-md border border-dashed p-3 text-xs">
      <p className="font-semibold text-muted-foreground">{title}</p>
      {children}
    </div>
  );
}
